import Vue from 'vue'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import router from './router'
import App from './App.vue'
import moment from 'moment'
import { i18n } from './locales/i18n-setup'
import VueMomentJS from 'vue-momentjs'
import store from './store/store'
import nsTranslations from './mixins/nsTranslations'
import validationRules from './mixins/validationRules'
import notificationHandler from './mixins/notificationHandler'
import './utils/referralToSessionStorage'
import './registerServiceWorker'

import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import { abilitiesPlugin } from '@casl/vue'
import { ability } from './permissions/rules'

import AppLayout from './components/layouts/AppLayout'
import WebsiteLayout from './components/layouts/WebsiteLayout'

Vue.use(Vuetify, {
  theme: {
    primary: '#607d8b', // #E53935
    secondary: '#455a64', // #FFCDD2
    accent: '#fdd835' // #3F51B5
  }
})
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(VueMomentJS, moment)
Vue.use(abilitiesPlugin, ability)

if (process.env.node_env === 'production') {
  Raven
    .config('https://46047e6bc711476e84e24315016bc82b@sentry.mediaformat.de/3')
    .addPlugin(RavenVue, Vue)
    .install()

  Vue.config.errorHandler = err => Vue.rollbar.error(err)
}

// global components
Vue.component('AppLayout', AppLayout)
Vue.component('WebsiteLayout', WebsiteLayout)

Vue.mixin(nsTranslations)
Vue.mixin(validationRules)
Vue.mixin(notificationHandler)

new Vue(Vue.util.extend({ router, store, i18n }, App)).$mount('#app')
